import EventDispatcher from "../../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher";
import { getURLParameter } from "../../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import GameConfig from "./GameConfig";
import ScenarioState from "./ScenarioState";

export default class GameModel extends EventDispatcher {

    /**
     * @param {GameConfig} gameConfig 
     */
    constructor(gameConfig) {
        super();
        /** @type {ScenarioState[]} */
        this._scenarioStates = [];
        this._gameConfig = gameConfig;
        this._completed = false;
        this.elapsedTime = 0;

        /** @type {String} */
        this.skipToDialogId = ranj.DEBUG ? getURLParameter("dialog") : null;

        createjs.Ticker.addEventListener("tick", this._handleTick.bind(this))
    }

    _handleTick(e) {
        this.elapsedTime += e.delta;
    }

    set restoredFeedbackPending(bool) {
        this._restoredFeedbackPending = bool;
    }
    get restoredFeedbackPending() {
        return this._restoredFeedbackPending;
    }

    /**
     * @param msecs {Number} msecs since start of gameplay
     */
    set elapsedTime(msecs) {
        this._startTime = Date.now() - msecs;
    }

    get elapsedTime() {
        return Date.now() - this._startTime;
    }

    set currentDialogPlayer(value) {
        this._dialogPlayer = value;
    }

    get currentDialogPlayer() {
        return this._dialogPlayer;
    }

    get completed() {
        const isAnyEpisodeNotCompleted = !!this.scenarioStates.find(scenarioState => scenarioState.state !== ScenarioState.STATE_FINISHED);
        return !isAnyEpisodeNotCompleted;
    }

    /** @returns {ScenarioState[]} */
    get scenarioStates() {
        return this._scenarioStates;
    }

    isScenarioCompleted(scenarioId){
        const scenarioState = this._scenarioStates.find(s => s.id == scenarioId);
        return scenarioState.state === ScenarioState.STATE_FINISHED;
    }

    setScenarioStatesFromObject(obj) {
        this._scenarioStates = obj.map(episodeObj => new ScenarioState(episodeObj.id, episodeObj.state));
    }

    completeScenario(scenarioId) {
        const scenarioState = this._scenarioStates.find(s => s.id == scenarioId);
        scenarioState.state = ScenarioState.STATE_FINISHED;
    }
}